"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("../../routing/router");
class Navbar extends HTMLElement {
    static tag = "nav-bar";
    static html = `
    <nav>
      <route-link href="${router_1.RouteEnum.home}">RBGo</route-link>
      <route-link href="${router_1.RouteEnum.gameRecords}">Partidas</route-link>
      <route-link href="${router_1.RouteEnum.players}">Jogadores</route-link>
      <route-link href="${router_1.RouteEnum.gameEvents}">Eventos</route-link>
      <route-link href="${router_1.RouteEnum.about}">?</route-link>
      <route-link href="${router_1.RouteEnum.search}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z" />
        </svg>
      </route-link>
    </nav>
  `;
    constructor() {
        super();
    }
    connectedCallback() {
        this.innerHTML = Navbar.html;
    }
}
exports.default = Navbar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF2YmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3VpL2NvbXBvbmVudHMvbmF2YmFyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaURBQWlEO0FBRWpELE1BQXFCLE1BQU8sU0FBUSxXQUFXO0lBQzdDLE1BQU0sQ0FBVSxHQUFHLEdBQVcsU0FBUyxDQUFDO0lBRWhDLE1BQU0sQ0FBVSxJQUFJLEdBQW9COzswQkFFeEIsa0JBQVMsQ0FBQyxJQUFJOzBCQUNkLGtCQUFTLENBQUMsV0FBVzswQkFDckIsa0JBQVMsQ0FBQyxPQUFPOzBCQUNqQixrQkFBUyxDQUFDLFVBQVU7MEJBQ3BCLGtCQUFTLENBQUMsS0FBSzswQkFDZixrQkFBUyxDQUFDLE1BQU07Ozs7OztHQU12QyxDQUFDO0lBRUY7UUFDRSxLQUFLLEVBQUUsQ0FBQztJQUNWLENBQUM7SUFFRCxpQkFBaUI7UUFDZixJQUFJLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUM7SUFDL0IsQ0FBQzs7QUF4QkgseUJBeUJDIn0=